const SET = 'scroll/setScrollRestoredSelf/SET'

export const setScrollRestoredSelf = scrollRestoredSelf => {
  return {
    scrollRestoredSelf,
    type: SET,
  }
}

export default (state = false, action) => {
  switch (action.type) {
    case SET:
      return action.scrollRestoredSelf || false
    default:
      return state
  }
}
